module.exports = __webpack_public_path__ + "img/power-op-apk_2x.8070a089.png";